"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoDataFallback = void 0;
var no_data_fallback_component_1 = require("./no-data-fallback.component");
Object.defineProperty(exports, "NoDataFallback", { enumerable: true, get: function () { return no_data_fallback_component_1.NoDataFallback; } });
